import { createApp } from "vue";
import VueGtag from "vue-gtag";
import { createMetaManager } from "vue-meta";
import { clerkPlugin } from '@clerk/vue';
import "@/style.css";
import App from "./App.vue";
import i18n, { loadStoredLanguage } from "./i18n";
import router from "./router/router";
import vuetify from './plugins/vuetify'
import "@mdi/font/css/materialdesignicons.css"
import "./style.css";
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

// Load stored language preference
loadStoredLanguage();

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)

if (!PUBLISHABLE_KEY) {
  throw new Error('Add your Clerk Publishable Key to the .env file')
}

const app = createApp(App)
  .use(clerkPlugin, {
    publishableKey: PUBLISHABLE_KEY,
  })
  .use(pinia)
  .use(router)
  .use(i18n)
  .use(vuetify)
  .use(createMetaManager())
  .use(VueGtag, {
    config: { id: import.meta.env.VITE_GA_MEASUREMENT_ID },
  });

await router.isReady();
app.mount("#app");
